import $ from "jquery";
import {selectedCstationStyle, selectedSegmentStyle} from "../map_styles/lineStyle";
import {assignmentlayer} from "../layers/activeLayers";
import {directionArray, trafficAgg} from "./lineFunctions";
import {totLineInfo} from "../infoDisplays/totalLineInfo";
import {cstationLineInfo, indLineInfo} from "../infoDisplays/individualLineInfo";
import {GeoJSON, WKT} from "ol/format";
import {otherinfo} from "../supportFunctions/consts";
import {checkAssignmentMode} from "../assignments/assignmentActions";

//create function to handle individual line parsing
function individualLineInfo(features,network_year) {
    otherinfo.html('')
    //set header for info box since additional info will be in loop
    otherinfo.html('<h4> Individual Segment Info</h4>')
    $.each(features,function (index,value) {
        //get geometries of the current segment
        let linewktGeom = new WKT().writeFeature(value);
        let linegeojsonObject = new GeoJSON().writeFeature(value);
        //get all properties about the current segment
        let props = value['values_']
        console.log(props)
        //get information about the opposite segment of the current segment
        let oppseg;
        let oppseggeom;
        let oppseglanes;
        if (props['segment_r'] === "-1") {
            oppseg = "-1"
        }
        else {
            if (network_year === 2016){
                oppseg = props['segment_r'] + "_" + props['region'];
            }
            if (network_year === 2021){
                oppseg = props['segment_r']
            }
            if (network_year === 2023){
                oppseg = props['segment_r']
            }
            if (network_year === 2025){
                oppseg = props['segment_r']
            }
            if (index === 0) {
                oppseggeom = new WKT().writeFeature(features[1])
                oppseglanes = features[1]['values_']['lanes']
            }
            if (index === 1) {
                oppseggeom = new WKT().writeFeature(features[0])
                oppseglanes = features[0]['values_']['lanes']
            }
        }
        //go to display control for individual segments
        indLineInfo(props,linegeojsonObject,linewktGeom,oppseg,oppseglanes,oppseggeom)
        console.log(indLineInfo)

    })
    // add 'add to assignment' button when in assignment mode
    if (checkAssignmentMode()) {
        $(".hiddentablerow").prop("hidden",false)
        console.log($(this).attr('id'))
        otherinfo.on('click',"[name='segbutton']", function () {
            document.getElementById('segListForm').value = $(this).attr('id');
            document.getElementById('selectedLineWKT').value = $(this).attr('data-linewkt');
            document.getElementById('segLanes').value = $(this).attr('data-segLanes');
            document.getElementById('selectedLineOppseg').value = $(this).attr('data-oppseg');
            document.getElementById('selectedLineOppseggeom').value = $(this).attr('data-oppsegwkt');
            document.getElementById('oppSegLanes').value = $(this).attr('data-oppsegLanes');
        })
    }
}

export function getLineShapes(segment_id,network_year){
    return {
        "url": process.env.appurl + "/api/getsegmentShapes/",
        "method": "get",
        "content-type": "application/json",
        "headers": {
            "Authorization": "Bearer " + localStorage.getItem('access_token')
        },
        "data": {
            "segment": segment_id,
            "network_year": network_year
        }
    }

}

const getFeatureLayer = function (feature) {
    return feature?.get?.('layer') || feature?.['values_']?.['layer'] || '';
}

const getNetworkYearFromLayer = function (layerName) {
    if (!layerName) {
        return null;
    }
    if (layerName.includes('2016r3_new_adjusted')) {
        return 2016;
    }
    if (layerName.includes('2021r1')) {
        return 2021;
    }
    if (layerName.includes('osm_2023')) {
        return 2023;
    }
    if (layerName.includes('osm_2025')) {
        return 2025;
    }
    return null;
}

export function lineHandler(features) {
    let numfeats = features['length']
    assignmentlayer.getSource().clear();

    if (numfeats === 0) {
        return;
    }

    const featureProps = features[0]['values_'];
    const layerName = getFeatureLayer(features[0]);

    if (layerName.includes('tab_cstation_traffic')) {
        let idprop = featureProps['cstationid']
        selectedCstationStyle(idprop)
        cstationLineInfo(featureProps)
        return;
    }

    const networkYear = getNetworkYearFromLayer(layerName);
    if (!networkYear) {
        console.warn('Unsupported segment layer clicked:', layerName, featureProps);
        return;
    }

    let idProp = networkYear === 2016 ? featureProps['segment_reg'] : featureProps['segment'];
    if (!idProp) {
        console.warn('Clicked segment is missing expected id property for network year:', networkYear, featureProps);
        return;
    }

    //check if there are too many segments selected
    if (numfeats <= 2) {
        console.log(features)
        //highlight on map
        selectedSegmentStyle(idProp,networkYear)
        //get info for all lines selected. link and street name just take the first since all lines are on top of each other
        let trafficAggs = trafficAgg(features)
        let directionAggs = directionArray(features)
        let link_id = networkYear === 2016 ? featureProps['link_id'] : idProp.split("_",1)
        let st_name = featureProps['st_name']
        //display the total link info in the top info box
        totLineInfo(numfeats,trafficAggs,directionAggs,link_id,st_name)
        //take the features and parse individually
        individualLineInfo(features, networkYear)
    }
    // if there's more than two segments, display the individual info for them all
    else {
        individualLineInfo(features,networkYear)
        //highlight only the first one on map since they all overlay each other anyway (not necessarily true)
        selectedSegmentStyle(idProp,networkYear)
        //add an alert in the map area
        $("#mapUtilsHeader").html('<h3> ! More than 2 segments Selected !<br></h3>')
    }
}





